import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, Popconfirm } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import Report from './report';
import View from './view';
import {
  checkResource,
  clearData,
  createResource,
  deleteResource,
  downloadASTCombineReport,
  downloadViewReport,
  fetchResource,
  getASTCombineReport,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource,
  addNewASTImage,
  updateAstAssetDetailField,
  removeAstAssetDetail
} from "../../appRedux/actions/AssetStockTaking";
import {
  checkQrAlreadyUsed,
  fetchFilter,
  fetchSubDocumentFilter,
  getAssetByQr,
  getSpareInventoryFilters,
  submitReport,
  getAssetByCode,
} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import { createResource as createLink } from '../../appRedux/actions/AssetLink';
import AccessControl from "../../components/AccessControl";
import { getAll as getAllTagTypes } from "../../appRedux/actions/AssetTagType";
import * as _ from 'lodash';
import CombineReport from "./CombineReport";
import Reconcilation from "./reconcilation";

export class AssetStockTaking extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  isImageUploading = (e) => {
    const { astUploadCount } = this.props;
    if (astUploadCount) {
      e.preventDefault();
      e.returnValue = `Images are Uploading. Please do not close the window until it get's completed`;
      return 'Images are Uploading';
    }
    return true;
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", this.isImageUploading);
  };

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
    this.setupBeforeUnloadListener();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.isImageUploading);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({
        visibleColumns: columns
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  checkResource = (values) => {
    this.props.checkResource(values);
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record, ...data) => (
        <div>
          {
            record && record.status === 'COMPLETED' ?
              <AccessControl resource={this.props.resourceName} permissionNeeded={'report'}
                roles={this.props.authUser ? this.props.authUser.roles : []}
                render={(props) => {
                  return <Button type="primary" style={{ marginRight: '10px' }} size='small'
                    onClick={() => this.report(record._id)}>Report</Button>
                }} /> : ''
          }
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button.Group>
                <Button type="primary" size='small'
                  onClick={() => this.view(record._id)}>View</Button>
                <Button size='small'
                  onClick={() => this.report(record._id, 'csv')}>CSV</Button>
              </Button.Group>
            }} />

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              const canDelete = record && record.status === 'OPEN';
              return <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={() => {
                  this.deleteResource(record._id)
                }}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
                disabled={!canDelete}
              >
                <Button style={{ marginLeft: '10px' }} type="danger" size='small'
                  disabled={!canDelete}
                  title={!canDelete ? 'Only records with status OPEN can be deleted' : ''}>Delete</Button>
              </Popconfirm>
            }} />

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values, update = false) => {
    this.props.createResource(values, update);
  };

  updateResource = (values, id, update = false) => {
    this.props.updateResource(values, id, update);
  };

  submitReport = (id) => {
    this.props.submitReport(id);
  }

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  view = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/view/${id}`);
  };

  report = (id, type) => {
    const { match } = this.props;
    if (type === 'csv') {
      this.props.downloadViewReport(id);
    } else {
      this.props.history.push(`${match.url}/difference-report/${id}`);
    }
  }

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "AssetStockTaking");
  }

  render() {
    const {
      match,
      data,
      resource,
      edit,
      fetchResource,
      loading,
      filters,
      modules,
      authUser,
      resourceName
    } = this.props;
    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);

    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
            visibleColumn={visibleColumns}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            filters={filters}
            subDocumentFilters={this.props.subDocumentFilters}
            match={match}
            clearData={this.props.clearData}
            history={this.props.history}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            warning={this.props.warning}
            onSubmit={this.createResource}
            onCheck={this.checkResource}
            loading={loading}
            viewEarlier={this.view}
            qrUsed={this.props.qrUsed}
            checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
            getAssetByQr={this.props.getAssetByQr}
            getAssetByCode={this.props.getAssetByCode}
            assetFromQr={this.props.assetFromQr}
            assetFromCode={this.props.assetFromCode}
            width={this.props.width}
            createLink={this.props.createLink}
            linkStatus={this.props.linkStatus}
            linkRecord={this.props.linkRecord}
            allTagTypes={this.props.allTagTypes}
            getAllTagTypes={this.props.getAllTagTypes}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            filters={filters}
            modules={modules}
            title={'EDIT'}
            clearData={this.props.clearData}
            match={match}
            history={this.props.history}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            warning={this.props.warning}
            onSubmit={this.updateResource}
            onCheck={this.checkResource}
            viewEarlier={this.view}
            loading={loading}
            authUser={authUser}
            qrUsed={this.props.qrUsed}
            checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
            getAssetByQr={this.props.getAssetByQr}
            getAssetByCode={this.props.getAssetByCode}
            assetFromQr={this.props.assetFromQr}
            assetFromCode={this.props.assetFromCode}
            width={this.props.width}
            createLink={this.props.createLink}
            linkStatus={this.props.linkStatus}
            linkRecord={this.props.linkRecord}
            allTagTypes={this.props.allTagTypes}
            getAllTagTypes={this.props.getAllTagTypes}
            {...props}
          />
          } />
        <Route path={`${match.url}/view/:id`}
          render={(props) => <View data={edit}
            filters={filters}
            modules={modules}
            title={'VIEW'}
            clearData={this.props.clearData}
            match={match}
            history={this.props.history}
            resource={resourceName}
            warning={this.props.warning}
            onCheck={this.checkResource}
            fetch={fetchResource}
            viewEarlier={this.view}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            submitReport={this.submitReport}
            loading={loading}
            authUser={authUser}
            onSubmitWithDocument={this.props.addNewASTImage}
            onUpdateAssetDetailField={this.props.updateAstAssetDetailField}
            onRemoveAssetDetail={this.props.removeAstAssetDetail}
            {...props}
          />
          } />
        <Route path={`${match.url}/difference-report/:id`}
          render={(props) => <Report data={edit}
            filters={filters}
            modules={modules}
            title={'VIEW'}
            clearData={this.props.clearData}
            match={match}
            history={this.props.history}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            {...props}
          />
          } />

        <Route path={`${match.url}/report`}
          render={(props) => <CombineReport data={null}
            filters={filters}
            modules={modules}
            title={'Report'}
            clearData={null}
            match={match}
            history={this.props.history}
            resource={resourceName}
            fetch={null}
            onChange={null}
            onSubmit={null}
            loading={loading}
            fetchLocSubLoc={this.props.getSpareInventoryFilters}
            locationData={this.props.locationsData}
            subLocationData={this.props.subLocationsData}
            fetchReportData={this.props.getASTCombineReport}
            combineReportData={this.props.combineReportData}
            downloadCombineData={this.props.downloadASTCombineReport}
            {...props}
          />
          } />

        {/* <Route path={`${match.url}/reconcilation`}
          render={(props) => <Reconcilation data={null}
            filters={filters}
            modules={modules}
            title={'Report'}
            clearData={null}
            match={match}
            history={this.props.history}
            resource={resourceName}
          />
          } /> */}
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({ auth, settings, assetStockTaking, commonData, spareInventoryReport, asset, assetLink, assetTagType }) => {
  return {
    width: settings.width,
    authUser: auth.authUser,
    total: assetStockTaking.total,
    data: assetStockTaking.resources,
    resource: assetStockTaking.resource,
    edit: assetStockTaking.edit,
    query: assetStockTaking.query,
    warning: assetStockTaking.warning,
    astUploadCount: assetStockTaking.astUploadCount,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    locationsData: spareInventoryReport.locations,
    subLocationsData: spareInventoryReport.subLocations,
    combineReportData: assetStockTaking.combineReportData,
    qrUsed: commonData.qrUsed,
    assetFromQr: asset.assetFromQr,
    assetFromCode: asset.assetFromCode,
    linkStatus: assetLink.linkStatus,
    linkRecord: assetLink.resource,
    allTagTypes: assetTagType.allTypes,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    checkResource,
    fetchSubDocumentFilter,
    clearData,
    submitReport,
    downloadViewReport,
    getSpareInventoryFilters,
    getASTCombineReport,
    downloadASTCombineReport,
    checkQrAlreadyUsed,
    getAssetByQr,
    getAssetByCode,
    createLink,
    getAllTagTypes,
    addNewASTImage,
    updateAstAssetDetailField,
    removeAstAssetDetail
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(AssetStockTaking);
